import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
  padding: ${rem(20)};
  width: ${rem(320)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(40)};
  }

  ${mediaQueryUp.largeDesktop} {
    padding: ${rem(60)};
  }
`

interface Props {
  to: string
}

function OfferCarouselLookingForSomethingElse(props: Props) {
  const { to } = props
  const intl = useIntl()

  return (
    <Container direction="vertical" horizontalAlign="center" verticalAlign="center" gap={24}>
      <VerticalSpacer gap={8}>
        <Heading align="center" variant="heading5">
          {intl.formatMessage({
            id: 'Mb9WCwcTmv',
            defaultMessage: 'Looking for something else?',
            description: 'Heading for looking for something else section in offer carousel',
          })}
        </Heading>
      </VerticalSpacer>
      <TextButton kind="primary" size="medium" shape="square" to={to}>
        {intl.formatMessage({
          id: 'XMHO6v1Xba',
          defaultMessage: 'View all',
          description: 'Button text to view all offers on the offer listing or detail page',
        })}
      </TextButton>
    </Container>
  )
}

export default React.memo(OfferCarouselLookingForSomethingElse)
